import './sidebar-list-item.scss';

import { isBoolean, isNil, map } from 'lodash';
import { useCallback } from 'react';

import { makeKeyDownHandler } from '../../data/utils/make-key-down-handler';
import { Avatar } from '../avatar/avatar/avatar';

type SidebarListItemProps = {
  type?: string;
  title: JSX.Element | string;
  values?: { [key: string]: JSX.Element | string | number | null | undefined };
  avatar?: JSX.Element | string | boolean;
  update?: boolean;
  active?: boolean;
  urgent?: boolean;
  onClick?: () => void;
};

export function SidebarListItem({
  type,
  title,
  values,
  avatar,
  update,
  active,
  urgent,
  onClick,
}: SidebarListItemProps) {
  const onHandleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <div
      className={`sidebar-list-item${
        type ? ` sidebar-list-item--${type}` : ``
      }${active ? ` active` : ``}${update ? ` update` : ``}${urgent ? ` sidebar-list-item--urgent` : ``}`}
      role="button"
      tabIndex={0}
      onClick={onHandleClick}
      onKeyDown={makeKeyDownHandler(onHandleClick)}
    >
      {(avatar ?? !!avatar) && (
        <div className="sidebar-list-item__avatar">
          {!isBoolean(avatar) && <Avatar text={avatar} />}
        </div>
      )}

      <div className="sidebar-list-item__content">
        {urgent && <span className="urgent">!</span>}
        <h3>{title}</h3>
        {map(values, (option, key) => {
          if (!isNil(option)) {
            return (
              <span key={key} className={key}>
                {option}
              </span>
            );
          }

          return undefined;
        })}
      </div>
    </div>
  );
}
